import {
  APCRGenericSlot,
  APGenericSlot,
  CourseGroupSlot,
  CourseSlot,
  NCRSlot,
  WildcardSlot
} from '../builders/ap_generic_slot_builder';
import { APProgramSlot } from '../builders/ap_program_slot_builder';

import * as _4 from 'lodash4';
import { APCourse } from '../builders/ap_course_builder';
import { INVALID_ID } from '../constants/ap_id_constants';

export class APGenericSlotServant {
  static isGenericSlotPlanned(genericSlot: APGenericSlot): boolean {
    if (APGenericSlotServant.isCourseSlot(genericSlot)) {
      return !_4.isEmpty(genericSlot.plannedCourse);
    }
    if (genericSlot.type === 'NCR') {
      return genericSlot.isPlanned;
    }
    // CourseGroup/Wildcard
    return !_4.isEmpty(genericSlot.plannedCourse) || !_4.isEmpty(genericSlot.plannedCourseGroup);
  }

  static isGenericSlotPlaceholderPlanned(genericSlot: APGenericSlot): boolean {
    return (
      APGenericSlotServant.isGenericSlotPlanned(genericSlot) &&
      APGenericSlotServant.isCourseGroupSlot(genericSlot) &&
      !!genericSlot.plannedCourseGroup.id
    );
  }

  static isGenericSlotInDegreeMap(genericSlot: APGenericSlot) {
    // disbled slot exist only in left side of the panel
    return genericSlot.disableSlot || genericSlot.termId === INVALID_ID;
  }

  static isGenericSlotCoursePlanned(
    genericSlot: Exclude<APGenericSlot, NCRSlot>
  ): genericSlot is APCRGenericSlot & { plannedCourse: NonNullable<APCRGenericSlot['plannedCourse']> } {
    return (
      APGenericSlotServant.isGenericSlotPlanned(genericSlot) &&
      !!genericSlot.plannedCourse &&
      !!genericSlot.plannedCourse.id
    );
  }

  static isSelectedLargeCourseGroup(
    selectedProgramSlot: Exclude<APGenericSlot['programSlot'], null>,
    programSlot: APProgramSlot
  ) {
    return (
      !_4.isEmpty(selectedProgramSlot) && !_4.isEmpty(programSlot) && _4.isEqual(selectedProgramSlot.id, programSlot.id)
    );
  }

  static isCourseGroupSlot(genericSlot: { type: APGenericSlot['type'] }): genericSlot is CourseGroupSlot {
    return genericSlot.type === 'GROUP';
  }

  static isNCRSlot(genericSlot: { type: APGenericSlot['type'] }): genericSlot is NCRSlot {
    return genericSlot.type === 'NCR';
  }

  static isWildcardSlot(genericSlot: { type: APGenericSlot['type'] }): genericSlot is WildcardSlot {
    return genericSlot.type === 'WILDCARD';
  }

  static isCourseSlot(genericSlot: { type: APGenericSlot['type'] }): genericSlot is CourseSlot {
    return genericSlot.type === 'COURSE';
  }

  static getCourseSlots(genericSlots: APGenericSlot[]) {
    return _4.filter(genericSlots, (genericSlot): genericSlot is CourseSlot =>
      APGenericSlotServant.isCourseSlot(genericSlot)
    );
  }
  static getWildCardSlots(genericSlots: APGenericSlot[]) {
    return _4.filter(genericSlots, (genericSlot): genericSlot is WildcardSlot =>
      APGenericSlotServant.isWildcardSlot(genericSlot)
    );
  }

  static uuid(slot: APGenericSlot) {
    const slotID = _4.get(slot, 'programSlot.id', 0);
    const slotCourseId = _4.get(slot, 'plannedCourse.id', 0);
    if (APGenericSlotServant.isCourseSlot(slot)) {
      return `${slot.termId}-${slotID}-${slot.course.id}-${slotCourseId}`;
    } else if (APGenericSlotServant.isWildcardSlot(slot)) {
      return `${slot.termId}-${slotID}-${_4.get(slot, 'course.id', 0)}-${slotCourseId}`;
    } else if (slot.type === 'NCR') {
      return `${slot.termId}-${slotID}`;
    } else {
      return `${slot.termId}-${slotID}-${slot.firstCourse.id}-${slotCourseId}`;
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/servants/ap_generic_slot_servant.ts